import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLoggedInUser } from '../logic/loginLogic';
import { logSecurityEvent, EVENT_TYPES } from '../utils/securityLogger';

const ProtectedRoute = ({ children }) => {
  const user = getLoggedInUser(); // ✅ Use session storage, not auth.currentUser
  
  // Log unauthorized access attempts
  if (!user) {
    logSecurityEvent(EVENT_TYPES.UNAUTHORIZED_ACCESS, null, {
      route: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
  }
  
  return user ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;